import { Component, inject } from '@angular/core';
import { SiteState } from '@next/core-lib/site';
import { Store, select } from '@ngrx/store';

import * as LegalStandardSelectors from '../store/legal-standard.selectors';

@Component({
  selector: 'app-nitrogen-cuts',
  templateUrl: './nitrogen-cuts.component.html',
  styleUrls: ['./nitrogen-cuts.component.scss'],
  standalone: false,
})
export class NitrogenCutsComponent {
  private readonly store = inject<Store<SiteState>>(Store);

  legalStandardBalance$ = this.store.pipe(
    select(LegalStandardSelectors.selectLegalStandardBalance),
  );
}
